<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isCharLooksSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{charLooksSidebarHeader}}</h4>
      <feather-icon icon="XIcon" @click.stop="isCharLooksSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" id="charLooksContent" :settings="settings">
      <div class="pl-6 pr-6" >
        <div>
          <label ref="nameLabel">Name</label>
          <vs-input autocomplete="off" v-validate="'required'" name="Name" v-model="charLookFormData.name" class="w-full" />
          <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
        </div>

        <div class="pt-4 pb-6" >
          <label>Description</label>
          <vs-textarea name="Description" v-model="charLookFormData.description" class="w-full" />
        </div>

        <img :src="charLookFormData.uploadedFileName" v-show="charLookFormData.uploadedFileName" @click="showUpload" width="100%" class="cursor-pointer">
        <!-- <vs-upload @on-success="successUpload" automatic :action="uploadLocation" text="Upload Image / GIF" class="img-upload pb-4" ref="fileUpload" accept="image/png,image/gif,image/jpeg" v-show="!charLookFormData.uploadedFileName" /> -->
        <div class="flex flex-wrap vs-con-loading__container items-center justify-center pb-4">
          <v-uploader id="fileUpload" @done="successUpload" v-show="!charLookFormData.uploadedFileName" ref="fileUpload" file-type-exts="jpeg,jpg,gif,png" button-text="Upload Image / GIF" language="en" file-size-limit="100MB" :preview="false" ></v-uploader>
        </div>

        <vs-divider>Voice Settings</vs-divider>

        <label>Voice</label>
        <vs-select placeholder="Search / Select Voice" class="w-full pb-5" vs-multiple autocomplete v-model="charLookFormData.voiceName" >
          <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in voices" />
        </vs-select>

        <label>Tempo ({{charLookFormData.voiceTempo}})</label>
        <vs-slider color="warning" max=10 v-model="charLookFormData.voiceTempo"/>

        <div class="md:w-1/6 ml-auto" >
          <vs-button ref="preview" radius :color="gradientColor1" :gradient-color-secondary="gradientColor2" type="gradient" class="vs-con-loading__container cursor-pointer" icon="settings_voice" @click="previewVoice" ></vs-button>
        </div>
        
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center pb-4 pt-1" slot="footer">
      <vs-button class="mr-4 vs-con-loading__container cursor-pointer" color="success" @click="updateApproach" :disabled="isDisabled" ref="addupdateButton">{{buttoncaption}}</vs-button>
      <vs-button color="danger" class="mr-4 vs-con-loading__container cursor-pointer" v-show="charLookFormData.id" @click="deleteCharLooks" ref="deleteButton">Delete</vs-button>
      <vs-button type="border" class="ml-4 cursor-pointer" color="warning" @click="isCharLooksSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";


export default {
  props: {
    isCharLooksSidebarActive: {
      type: Boolean,
      required: true
    },
    selectedCharLook: {
      type: Object,
      required: false
    },
    selectedCharId: {
      type: Number,
      required: false
    },
    buttoncaption: {
      type: String,
      required: false
    },
    charLooksSidebarHeader: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      backgroundLoading:'#fff',
      gradientColor1:'#c72a75',
      gradientColor2:'#5252e8',
      isLoading: false,
      charLookFormData: {
        id: 0,
        characterId: 0,
        name: "",
        description: "",
        uploadedFileName: "",
        voiceVolume: 0,
        voiceTempo: 0,
        voiceName: [],
        isUsed: false
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      voices:[
        {text:'Hedda (German, de-DE)',value:'Hedda'},
        {text:'Hazel (English en-GB)',value:'Hazel'},
        {text:'David (English en-US)',value:'David'},
        {text:'Zira (English en-US)',value:'Zira'},
        {text:'Helena (Spanish es-ES)',value:'Helena'},
        {text:'Hilda (Spanish es-MX',value:'Hilda'},
        {text:'Hortense (French fr-FR)',value:'Hortense'},
        {text:'Lucia (Italian it-IT)',value:'Lucia'},
        {text:'Haruka (Japanese ja-JP)',value:'Haruka'},
        {text:'Heami (Korean ko-KR)',value:'Heami'},
        {text:'Hedvig (Swedish sv-SE)',value:'Hedvig'},
        {text:'HuiHui (Chinese zh-CN)',value:'HuiHui'},
      ],
    };
  },
  computed: {
    isCharLooksSidebarActiveLocal: {
      get() {
        return this.isCharLooksSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeCharLooksSidebar");
          this.initValues();
        }
      }
    },
    isDisabled: function(){
     return !this.charLookFormData.name;
    },
    uploadLocation: {
      get() {
          return this.$buildUrl("tempupload");
      }
    },
  },
  watch: {
    isCharLooksSidebarActive: function(val) {
      var self = this;
      if(val){
        this.charLookFormData.characterId = this.selectedCharId;
        if(this.selectedCharLook.id) {
          this.charLookFormData.id = this.selectedCharLook.id;
          this.charLookFormData.name = this.selectedCharLook.name;
          this.charLookFormData.description = this.selectedCharLook.description;
          this.charLookFormData.uploadedFileName = this.selectedCharLook.imageUrl;
          this.charLookFormData.voiceVolume = this.selectedCharLook.voiceVolume;
          this.charLookFormData.voiceName = this.selectedCharLook.voiceName;
          this.charLookFormData.voiceTempo = this.selectedCharLook.voiceTempo;
          this.charLookFormData.isUsed = this.selectedCharLook.isUsed;
        }else {
          this.initValues();
        } 
      } else {
          var options = {
              container: '#charLooksContent',
              easing: 'ease-in',
              offset: -1000,
              force: true,
              cancelable: true,
              x: false,
          }

          var cancelScroll = this.$scrollTo(this.$refs["nameLabel"], 500, options);
      }
    }
  },
  methods: {
    initValues() {
      this.charLookFormData.id = 0;
      this.charLookFormData.name = "";
      this.charLookFormData.description = "";
      this.charLookFormData.uploadedFileName = "";
      this.charLookFormData.voiceName = "";
      this.charLookFormData.voiceVolume = 100;
      this.charLookFormData.voiceTempo = 4;
      this.isLoading = false;
      this.errors.clear();
    },
    saveData(){
     this.$emit('saveLookData');
     this.$vs.loading.close(this.$refs.addupdateButton.$el);
    },
    addEditCharLooks() {
      this.$validator.validateAll().then(result => {
        var self = this;
        if (result) {
          self.showLoadingOnButton();
          if(self.charLookFormData.isUsed)
            self.showLoadingOnList();

          var onSuccess = response => {
            self.saveData();
            self.$vs.notify({
              title:'Information',
              color: "success",
              text: "Character Look Saved",
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-save'
            });
          };
          var onFinally = function () {
            self.$vs.loading.close(self.$refs.addupdateButton.$el);
            self.$vs.loading.close(self.$parent.$el);
          };

          self.$ajaxPost(self, "character/addeditcharacterlooks", self.charLookFormData, onSuccess, onFinally);
        } else {
          self.$vs.notify({
            title:'Attention',
            color: "warning",
            text: self.$validator.errors.items[0].msg,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-info'
          });
        }
      });
    },
    deleteCharLooks() {
      var self = this;
      self.showLoadingOnDeleteButton();
      var onSuccess = response => {
        self.saveData();
        self.$vs.notify
          ({
          title: 'Information',
          color: "success",
          text: "Character Look Deleted",
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-trash',
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.deleteButton.$el);
      };
      self.$ajaxDelete(self, "character/removecharacterlooks/" + self.charLookFormData.id, onSuccess, onFinally);
    },
    showUpload() {
      this.charLookFormData.uploadedFileName = null;
    },
    successUpload(data) {
      this.charLookFormData.uploadedFileName = data[0].url;
      this.$vs.loading.close(this.$refs.fileUpload.$el);
      this.isLoading = false;
    },
    previewVoice() {
      var self = this;
      talkify.config = {
        remoteService: {
            host : 'https://talkify.net',
            speechBaseUrl: "/api/speech/v1",
            apiKey : '7dbb03ab-f8a5-4745-813b-1e644c70b00b',//'661fbcb8-e65f-42b3-aeab-3cd3edfefcbc',
            active: true //True to use Talkifys language engine and hosted voices. False only works for Html5Player.
        },
        ui:
        {
            audioControls: { //If enabled, replaces the built in audio controls. Especially good for the Web Speech API bits
                enabled: false
            }
        }
      }
      var player = new talkify.TtsPlayer();
      talkify.messageHub.subscribe("Stop Animation", "*.player.tts.pause", function(){
        self.$vs.loading.close(self.$refs.preview.$el);
      });
      player.forceVoice({name: this.charLookFormData.voiceName})
      player.setRate(this.charLookFormData.voiceTempo-5); // from -5 to 5
      player.playText('Hello. This is my voice you have chosen to preview.');
      if(player.isPlaying)
      {
        self.$vs.loading({
          background: self.gradientColor1,
          type: "sound",
          color: "#fff",
          container: self.$refs.preview.$el,
          scale: 0.45
        });
      }
    },
    showLoadingOnButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        //color: self.colorLoading,
        container: self.$refs.addupdateButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnDeleteButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        //color: self.colorLoading,
        container: self.$refs.deleteButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnList(){
      var self = this;
      self.$vs.loading({
        type: "corners",
        container: self.$parent.$el,
        scale: 1
      });
    },
    showLoadingOnUploader(){
      var self = this;
      self.isLoading = true;
      self.$vs.loading({
        type: "material",
        container: self.$refs.fileUpload.$el,
        scale: 0.45
      });
    },
    updateApproach() {
      if(this.charLookFormData.isUsed && this.charLookFormData.id)
        this.openConfirm();
      else
        this.addEditCharLooks();
    },
    openConfirm() {
      this.$emit("closeCharLooksSidebar");
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: `Attention`,
        text: 'The selected character look is being used in one or more dialog task(s).\n\nAre you sure you want to update it?',
        accept: this.addEditCharLooks,
        acceptText: "Yes, update",
        cancelText: "No, cancel"
      })
    },
  },
  mounted() {
    var self = this;
    self.$refs.fileUpload.$el.addEventListener("click", function(){
      if(!self.isLoading)
        self.showLoadingOnUploader();
      else{
        self.isLoading = false;
        self.$vs.loading.close(self.$refs.fileUpload.$el);
      }
    });
  },
  components: {
    VuePerfectScrollbar
  },
};
</script>

<style lang="scss" scoped>

  #talkify-audio{display: none;}
  
  .add-new-data-sidebar {
    /deep/ .vs-sidebar--background
    

    {
      z-index: 52010;
    }

    /deep/ .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;
      .img-upload
      {
        margin-top: 2rem;
        .con-img-upload

        {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }

      }
    }
  }

  .scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
  }
</style>
